import { Live2dTips } from './live2d-tips';
window.initLive2dWeb = initLive2dWeb;
function initLive2dWeb() {
    console.log('Live2DWebCanvas:', '1.9.10');
    let tips = new Live2dTips(live2d_settings);
    tips.initModel(live2d_settings.settings.modelId, live2d_settings.settings.modelTexturesId);
    tips.initTips();
}
